import type { SyncrelEntity, SyncrelState } from "../domain/types";
import { visibleFrameworkEntities } from "../domain/framework-scope";

export const escapeHtml = (value: unknown): string => String(value ?? "")
  .replaceAll("&", "&amp;")
  .replaceAll("<", "&lt;")
  .replaceAll(">", "&gt;")
  .replaceAll('"', "&quot;")
  .replaceAll("'", "&#039;");

export const selectedEntity = (state: SyncrelState): SyncrelEntity | null => {
  const entities = visibleFrameworkEntities(state);
  return entities.find((entity) => entity.id === state.workspace.selectedEntityId) ?? entities[0] ?? null;
};

export const numberFormat = new Intl.NumberFormat("en", {
  maximumFractionDigits: 2,
});

export const currencyFormat = new Intl.NumberFormat("en", {
  style: "currency",
  currency: "USD",
  maximumFractionDigits: 0,
});

export const fieldValue = (entity: SyncrelEntity, key: string): string => {
  const value = entity.fields[key];
  if (typeof value === "number") return numberFormat.format(value);
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value ?? "");
};

export const readField = (entity: SyncrelEntity, key: string): unknown => entity.fields[key] ?? "";
